import React from "react";
import { Link } from "react-router-dom";
import { formatCurrency } from "../../../../utils/formatCurrency";

function formatDate(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

/**
 * Table of last 5 pending orders (last_5_pending_orders from dashboard API).
 * @param {{ data: Array<{ id: number, invoice_no: string, total_price: number, payable_amount: number, created_at: string, customer: string }> }} props
 */
const LastPendingOrdersTable = ({ data = [] }) => {
  if (!data || data.length === 0) {
    return (
      <div className="text-muted text-center py-4">No pending orders</div>
    );
  }

  return (
    <div className="table-responsive">
      <table className="table table-hover mb-0">
        <thead>
          <tr>
            <th>Invoice</th>
            <th>Customer</th>
            <th className="text-end">Amount</th>
            <th>Date</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {data.map((row) => (
            <tr key={row.id}>
              <td>
                <code className="small">{row.invoice_no || "—"}</code>
              </td>
              <td>
                <span className="text-dark">{row.customer || "—"}</span>
              </td>
              <td className="text-end">
                {formatCurrency(parseFloat(row.payable_amount))}
              </td>
              <td className="small text-muted">{formatDate(row.created_at)}</td>
              <td>
                <Link
                  to={`/invoice-page/${row.id}`}
                  className="btn btn-sm btn-outline-primary"
                >
                  View
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default LastPendingOrdersTable;
